<ion-content class="background">
  <div class="header-page">
    <app-header-not-buttons></app-header-not-buttons>

    <app-title-three title="Registro"></app-title-three>
  </div>

  <app-title-two title="Ingresa tus datos"></app-title-two>

  <form [formGroup]="createForm">
    <ion-grid class="form-data">
      <ion-row>
        <ion-col size="12">
          <ion-item>
            <ion-label position="floating" color="tertiary">Rol *</ion-label>
            <ion-select
              formControlName="rol_id"
              okText="Aceptar"
              cancelText="Cancelar"
              (ionChange)="enableForm()"
              interface="popover"
              mode="md"
            >
              <ion-select-option class="custom-options-rols" *ngFor="let rol of rols" [value]="rol.id"
                >{{ rol.name }}</ion-select-option
              >
            </ion-select>
          </ion-item>

          <div
            class="div message-errors"
            *ngIf="(errorControl.rol_id.touched || errorControl.rol_id.dirty) && errorControl.rol_id.errors"
          >
            <ng-container *ngFor="let validation of validationMessages.rol_id">
              <div *ngIf="errorControl.rol_id.hasError(validation.type)">
                <ion-text color="primary" class="messages-alert">{{ validation.message }}</ion-text>
              </div>
            </ng-container>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-accordion-group *ngIf="statusForm" [multiple]="true" [value]="['first']">
      <ion-accordion value="first" toggleIcon="arrow-down-outline">
        <ion-item slot="header" class="header-accordion" color="white">
          <ion-label>Crea tu usuario</ion-label>
        </ion-item>
        <div slot="content">
          <ion-grid class="form-data">
            <ion-row>
              <div class="info-register">
                <ion-col size="12">
                  <ion-item>
                    <ion-label position="floating" color="tertiary">Nombres *</ion-label>
                    <ion-input mode="md" formControlName="first_name" maxlength="50" id="first_name" type="text">
                    </ion-input>
                  </ion-item>
                  <div
                    class="div message-errors"
                    *ngIf="(errorControl.first_name.touched || errorControl.first_name.dirty) && errorControl.first_name.errors"
                  >
                    <ng-container *ngFor="let validation of validationMessages.first_name">
                      <div *ngIf="errorControl.first_name.hasError(validation.type)">
                        <ion-text color="primary" class="messages-alert">{{ validation.message }}</ion-text>
                      </div>
                    </ng-container>
                  </div>
                  <ion-item>
                    <ion-label position="floating" color="tertiary">Apellidos *</ion-label>
                    <ion-input mode="md" formControlName="last_name" maxlength="50" id="last_name" type="text">
                    </ion-input>
                  </ion-item>
                  <div
                    class="div message-errors"
                    *ngIf="(errorControl.last_name.touched || errorControl.last_name.dirty) && errorControl.last_name.errors"
                  >
                    <ng-container *ngFor="let validation of validationMessages.last_name">
                      <div *ngIf="errorControl.last_name.hasError(validation.type)">
                        <ion-text color="primary" class="messages-alert">{{ validation.message }}</ion-text>
                      </div>
                    </ng-container>
                  </div>

                  <ion-item lines="none" class="group-item">
                    <ion-label color="tertiary" class="label-input">Correo Electrónico *</ion-label></ion-item
                  >

                  <ion-item
                    [ngClass]="{'input-error': ( errorControl.email.touched ||  errorControl.email.dirty) &&  errorControl.email.errors}"
                  >
                    <input
                      (input)="onInput($event)"
                      [nzAutocomplete]="auto"
                      formControlName="email"
                      maxlength="50"
                      id="email"
                      type="text"
                      class="input"
                      color="tertiary"
                    />
                    <nz-autocomplete #auto>
                      <nz-auto-option *ngFor="let option of options" [nzValue]="option">{{ option }}</nz-auto-option>
                    </nz-autocomplete>
                  </ion-item>
                  <div
                    class="div message-errors"
                    *ngIf="(errorControl.email.touched || errorControl.email.dirty) && errorControl.email.errors"
                  >
                    <ng-container *ngFor="let validation of validationMessages.email">
                      <div *ngIf="errorControl.email.hasError(validation.type)">
                        <ion-text color="primary" class="messages-alert">{{ validation.message }}</ion-text>
                      </div>
                    </ng-container>
                  </div>

                  <ion-item>
                    <ion-label position="floating" color="tertiary">Contraseña *</ion-label>
                    <ion-input
                      mode="md"
                      formControlName="password"
                      maxlength="15"
                      maxlength="15"
                      id="password"
                      [type]="typeInput[0]"
                    >
                    </ion-input>
                    <ion-icon
                      slot="end"
                      [name]="eyeImage[0]"
                      style="
                        position: absolute;
                        bottom: -15px;
                        right: 0px;
                        transform: translate(-50%, -50%);
                        z-index: 2;
                      "
                      (click)="changeImage(0)"
                      mode="md"
                    ></ion-icon>
                  </ion-item>
                  <div
                    class="div message-errors"
                    *ngIf="(errorControl.password.touched || errorControl.password.dirty) && errorControl.password.errors"
                  >
                    <ng-container *ngFor="let validation of validationMessages.password">
                      <div *ngIf="errorControl.password.hasError(validation.type)">
                        <ion-text color="primary" class="messages-alert">{{ validation.message }}</ion-text>
                      </div>
                    </ng-container>
                  </div>
                  <ion-item>
                    <ion-label position="floating" color="tertiary">Repetir contraseña *</ion-label>
                    <ion-input
                      mode="md"
                      formControlName="confirm_password"
                      maxlength="15"
                      id="confirm_password"
                      [type]="typeInput[1]"
                    >
                    </ion-input>
                    <ion-icon
                      slot="end"
                      [name]="eyeImage[1]"
                      style="
                        position: absolute;
                        bottom: -15px;
                        right: 0px;
                        transform: translate(-50%, -50%);
                        z-index: 2;
                      "
                      (click)="changeImage(1)"
                      mode="md"
                    ></ion-icon>
                  </ion-item>
                  <div
                    class="div message-errors"
                    *ngIf="(errorControl.confirm_password.touched || errorControl.confirm_password.dirty) && errorControl.confirm_password.errors"
                  >
                    <ng-container *ngFor="let validation of validationMessages.confirm_password">
                      <div *ngIf="errorControl.confirm_password.hasError(validation.type)">
                        <ion-text color="primary" class="messages-alert">{{ validation.message }}</ion-text>
                      </div>
                    </ng-container>
                  </div>
                  <div *ngIf="errorControl.confirm_password.errors != null">
                    <div *ngIf="errorControl.confirm_password.value != errorControl.password.value">
                      <ion-text color="primary" class="messages-alert">Las contraseñas deben de ser iguales.</ion-text>
                    </div>
                  </div>
                </ion-col>
                <!-- Tuition -->
                <ion-col size="12">
                  <ion-item *ngIf="permissions[1]">
                    <ion-label position="floating" color="tertiary">{{"Matrícula" | translate }} *</ion-label>
                    <ion-input mode="md" formControlName="tuition" maxlength="30" id="tuition" type="text"> </ion-input>
                  </ion-item>
                  <div
                    class="div message-errors"
                    *ngIf="(errorControl.tuition.touched || errorControl.tuition.dirty) && errorControl.tuition.errors"
                  >
                    <ng-container *ngFor="let validation of validationMessages.tuition">
                      <div *ngIf="errorControl.tuition.hasError(validation.type)">
                        <ion-text color="primary" class="messages-alert">{{ validation.message | translate }}</ion-text>
                      </div>
                    </ng-container>
                  </div>
                </ion-col>

                <!-- Input Cédula -->
                <ion-col size="12">
                  <ion-item>
                    <ion-label position="floating" color="tertiary">{{ "Cédula" | translate }} *</ion-label>
                    <ion-input
                      mode="md"
                      type="text"
                      formControlName="ced_user"
                      maxlength="30"
                      id="ced_user"
                    ></ion-input>
                  </ion-item>
                  <div
                    class="div message-errors"
                    *ngIf="(errorControl.ced_user.touched || errorControl.ced_user.dirty) && errorControl.ced_user.errors"
                  >
                    <ng-container *ngFor="let validation of validationMessages.ced_user">
                      <div *ngIf="errorControl.ced_user.hasError(validation.type)">
                        <ion-text color="primary" class="messages-alert">{{validation.message | translate }}</ion-text>
                      </div>
                    </ng-container>
                  </div>
                </ion-col>

                <!-- Especialidad -->
                <ion-col size="12">
                  <ion-item
                    *ngIf="permissions[0]"
                    [ngClass]="{'input-error': ( errorControl.specialty_name.touched ||  errorControl.specialty_name.dirty) &&  errorControl.specialty_name.errors}"
                  >
                    <ion-label color="tertiary" class="label-input">Especialidad *</ion-label>
                    <ionic-selectable
                      #specialty
                      formControlName="specialty_name"
                      item-content
                      itemValueField="name"
                      itemTextField="name"
                      [items]="specialties"
                      [canSearch]="true"
                      closeButtonText="Cancelar"
                      searchButtonText="Buscar"
                      searchPlaceholder="Buscar"
                      searchFailText="No se ha encontrado ningún registro"
                    >
                    </ionic-selectable>
                  </ion-item>
                  <div class="div message-errors" *ngIf="errorControl.specialty_name.errors != null">
                    <div
                      *ngIf="
                            (errorControl.specialty_name.touched || errorControl.specialty_name.dirty) &&
                            errorControl.specialty_name.errors.required
                          "
                    >
                      <ion-text color="primary" class="messages-alert">La especialidad es requerida. </ion-text>
                    </div>
                  </div>
                </ion-col>

                <!-- Provincia -->
                <ion-col size="12">
                  <ion-item>
                    <ion-label>{{ "Provincia" | translate }} *</ion-label>
                    <ionic-selectable
                      #city
                      formControlName="state_id"
                      id="state_id"
                      item-content
                      itemValueField="id"
                      itemTextField="name"
                      [items]="states"
                      [canSearch]="true"
                      (onChange)="loadCities()"
                      closeButtonText="Cancelar"
                      searchButtonText="Buscar"
                      searchPlaceholder="Buscar"
                      searchFailText="No se ha encontrado ningún registro"
                    >
                    </ionic-selectable>
                  </ion-item>
                  <div class="div message-errors" *ngIf="errorControl.state_id.errors != null">
                    <div
                      *ngIf="
                        (errorControl.state_id.touched || errorControl.state_id.dirty) &&
                        errorControl.state_id.errors.required
                      "
                    >
                      <ion-text color="primary" class="messages-alert"
                        >{{ "La provincia es requerida." | translate }}</ion-text
                      >
                    </div>
                  </div>
                </ion-col>
                <!-- Localidad -->
                <ion-col size="12">
                  <ion-item>
                    <ion-label>{{"Localidad" | translate }} *</ion-label>
                    <ionic-selectable
                      #city
                      formControlName="city_id"
                      item-content
                      itemValueField="id"
                      itemTextField="name"
                      [items]="cities"
                      [canSearch]="true"
                      closeButtonText="Cancelar"
                      searchButtonText="Buscar"
                      (onChange)="loadPrefix()"
                      searchPlaceholder="Buscar"
                      searchFailText="No se ha encontrado ningún registro"
                    >
                    </ionic-selectable>
                  </ion-item>
                  <div class="div message-errors" *ngIf="errorControl.city_id.errors != null">
                    <div
                      *ngIf="
                        (errorControl.city_id.touched || errorControl.city_id.dirty) &&
                        errorControl.city_id.errors.required
                      "
                    >
                      <ion-text color="primary" class="messages-alert"
                        >{{"La localidad es requerida." | translate }}</ion-text
                      >
                    </div>
                  </div>
                </ion-col>

                <!-- Cod. Pais 1 -->
                <ion-col size="12" class="hide">
                  <ion-item>
                    <ion-label position="floating" color="tertiary">Cod. País *</ion-label>
                    <ion-input
                      mode="md"
                      formControlName="country_code_phone"
                      maxlength="15"
                      id="country_code_phone"
                      type="text"
                    >
                    </ion-input>
                  </ion-item>

                  <div *ngIf="errorControl.country_code_phone.errors != null">
                    <div
                      *ngIf="( errorControl.country_code_phone.touched ||  errorControl.country_code_phone.dirty) &&  errorControl.country_code_phone.errors.nameNumberMin"
                    >
                      <ion-text color="primary" class="messages-alert">Debe tener más de 1 carácter.</ion-text>
                    </div>
                    <div
                      *ngIf="( errorControl.country_code_phone.touched ||  errorControl.country_code_phone.dirty) &&  errorControl.country_code_phone.errors.nameNumberMax"
                    >
                      <ion-text color="primary" class="messages-alert">Debe tener máximo 2 caracteres.</ion-text>
                    </div>
                    <div
                      *ngIf="( errorControl.country_code_phone.touched ||  errorControl.country_code_phone.dirty) &&  errorControl.country_code_phone.errors.nameText"
                    >
                      <ion-text color="primary" class="messages-alert">Ingrese un código de teléfono válido.</ion-text>
                    </div>
                    <div
                      *ngIf="( errorControl.country_code_phone.touched ||  errorControl.country_code_phone.dirty) &&  errorControl.country_code_phone.errors.nameRequerid"
                    >
                      <ion-text color="primary" class="messages-alert">El código de teléfono es requerido.</ion-text>
                    </div>
                  </div>
                </ion-col>
              </div>
            </ion-row>
            <ion-row>
              <ion-col size="12">
                <ion-label position="floating" color="tertiary">Teléfono 1 *</ion-label>
              </ion-col>
              <ion-col size="3">
                <ion-item>
                  <p class="p-pt">(</p>
                  <ion-input
                    mode="md"
                    formControlName="prefix"
                    maxlength="5"
                    id="prefix"
                    type="text"
                    class="center-text-input"
                  >
                  </ion-input>
                  <p class="p-pt">) -</p>
                </ion-item>

                <div
                  class="div message-errors"
                  *ngIf="(errorControl.ced_user.touched || errorControl.ced_user.dirty) && errorControl.ced_user.errors"
                >
                  <ng-container *ngFor="let validation of validationMessages.ced_user">
                    <div *ngIf="errorControl.phone_number.hasError(validation.type)">
                      <ion-text color="primary" class="messages-alert">{{validation.message | translate }}</ion-text>
                    </div>
                  </ng-container>
                </div>
              </ion-col>
              <ion-col size="9" class="col-pt">
                <ion-item>
                  <ion-input mode="md" formControlName="phone_number" maxlength="15" id="phone_number" type="text">
                  </ion-input>
                </ion-item>

                <div
                  class="div message-errors"
                  *ngIf="(errorControl.phone_number.touched || errorControl.phone_number.dirty) && errorControl.phone_number.errors"
                >
                  <ng-container *ngFor="let validation of validationMessages.phone_number">
                    <div *ngIf="errorControl.phone_number.hasError(validation.type)">
                      <ion-text color="primary" class="messages-alert">{{validation.message | translate }}</ion-text>
                    </div>
                  </ng-container>
                </div>
              </ion-col>
              <ion-col size="12" *ngIf="!validationReqPrefix">
                <ion-text color="tertiary" class="messages-alert">En caso de teléfono fijo agregar prefijo.</ion-text>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size="12">
                <ion-label position="floating" color="tertiary">Teléfono 2</ion-label>
              </ion-col>
              <ion-col size="3">
                <ion-item>
                  <p class="p-pt">(</p>
                  <ion-input
                    mode="md"
                    formControlName="prefix_2"
                    maxlength="5"
                    id="prefix_2"
                    type="text"
                    class="center-text-input"
                  >
                  </ion-input>
                  <p class="p-pt">) -</p>
                </ion-item>

                <div
                  class="div message-errors"
                  *ngIf="(errorControl.prefix_2.touched || errorControl.prefix_2.dirty) && errorControl.prefix_2.errors"
                >
                  <ng-container *ngFor="let validation of validationMessages.prefix_2">
                    <div *ngIf="errorControl.prefix_2.hasError(validation.type)">
                      <ion-text color="primary" class="messages-alert">{{validation.message | translate }}</ion-text>
                    </div>
                  </ng-container>
                </div>
              </ion-col>
              <ion-col size="9" class="col-pt">
                <ion-item>
                  <ion-input mode="md" formControlName="phone_number_2" maxlength="15" id="phone_number_2" type="text">
                  </ion-input>
                </ion-item>

                <div
                  class="div message-errors"
                  *ngIf="(errorControl.phone_number_2.touched || errorControl.phone_number_2.dirty) && errorControl.phone_number_2.errors"
                >
                  <ng-container *ngFor="let validation of validationMessages.phone_number_2">
                    <div *ngIf="errorControl.phone_number_2.hasError(validation.type)">
                      <ion-text color="primary" class="messages-alert">{{validation.message | translate }}</ion-text>
                    </div>
                  </ng-container>
                </div>
              </ion-col>
              <ion-col size="12" *ngIf="!validationReqPrefix">
                <ion-text color="tertiary" class="messages-alert">En caso de teléfono fijo agregar prefijo.</ion-text>
              </ion-col>
            </ion-row>
            <ion-row>
              <div class="info-register">
                <!-- Términos -->
                <ion-col size="12">
                  <ion-list class="checks">
                    <ion-item lines="none">
                      <ion-label>Términos y Condiciones *</ion-label>
                      <ion-checkbox
                        color="primary"
                        slot="start"
                        id="agreeTerms"
                        formControlName="agreeTerms"
                        name="terms"
                        value="agree"
                        md="ios"
                        (click)="Terms()"
                      ></ion-checkbox>
                    </ion-item>
                    <ion-item lines="none">
                      <ion-label>Manejo de Datos Personales *</ion-label>
                      <ion-checkbox
                        color="primary"
                        slot="start"
                        id="agreePrivacy"
                        formControlName="agreePrivacy"
                        name="privacy"
                        value="agree"
                        md="ios"
                        (click)="Consent()"
                      ></ion-checkbox>
                    </ion-item>
                    <ion-item lines="none">
                      <ion-label>Aviso de Compliance *</ion-label>
                      <ion-checkbox
                        color="primary"
                        slot="start"
                        id="agreeCompliance"
                        formControlName="agreeCompliance"
                        name="compliance"
                        value="agree"
                        md="ios"
                        (click)="Compliance()"
                      ></ion-checkbox>
                    </ion-item>
                    <ion-item lines="none">
                      <ion-label (click)="Farmaco()" class="pointer">Aviso de Farmacovigilancia</ion-label>
                    </ion-item>
                  </ion-list>
                </ion-col>
              </div>
            </ion-row>
          </ion-grid>
        </div>
      </ion-accordion>
    </ion-accordion-group>

    <ion-grid class="form-data">
      <ion-row>
        <ion-col class="ion-text-center" *ngIf="statusForm">
          <button
            shape="round"
            type="submit"
            [disabled]="createForm.invalid"
            id="btn-create"
            class="btn-primary"
            (click)="create()"
          >
            Registrarse
          </button>
        </ion-col>

        <ion-col size="12" class="center">
          <button (click)="closeModal()" shape="round" class="btn-primary btn-close">Cerrar</button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>
